import { render, staticRenderFns } from "./InfoColorUpReview.vue?vue&type=template&id=02f4c1b8&scoped=true&"
import script from "./InfoColorUpReview.vue?vue&type=script&lang=js&"
export * from "./InfoColorUpReview.vue?vue&type=script&lang=js&"
import style0 from "./InfoColorUpReview.vue?vue&type=style&index=0&id=02f4c1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f4c1b8",
  null
  
)

export default component.exports